import { Button, Form, Input, Modal, Select } from "antd";
import { useEffect, useState } from "react";
import { getEkoCreditCardBanks, PayCreditCardBill } from "../EkoEndpoint";
import CommonInput from "../../../../Common/CommonInput";
import {
  creditCardValidation,
  dispatchtoast,
  filterOption,
  getLocalStorageItem,
  ifscPattern,
  pincodePattern,
} from "../../../../Utils";
import { getPayoutAndDmtOtp } from "../../../../ApiServices/Apifun";
import { useDispatch } from "react-redux";
import { setselectedTab } from "../../../../Store/B2bslice";

const EkoCreditCard = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [btnLoading, setBtnLoading] = useState(false);
  const [openOtpModal, setOpenOtpModal] = useState(false);
  const [otpUid, setOtpUid] = useState(null);
  const [otp, setOtp] = useState(null);
  const [filledDetails, setFilledDetails] = useState(null);
  const [creditCardbanks, setcreditCardbanks] = useState([]);

  const handleGetbank = () => {
    getEkoCreditCardBanks()
      .then((res) => {
        setcreditCardbanks(
          res.banks.map((i) => {
            return {
              label: i?.bank_name,
              // <p
              //   onClick={() => {
              //     form.setFieldsValue({
              //       bank_name: i?.bank_name,
              //       bank_code: i?.bank_code,
              //       bank_ifsc: i?.bank_ifsc,
              //     });
              //   }}
              // >

              // </p>
              value: i?.id,
            };
          }),
        );
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    handleGetbank();
    dispatch(setselectedTab("300.11"));
  }, []);

  const handlePay = (v) => {
    setFilledDetails(v);
    setBtnLoading(true);
    getPayoutAndDmtOtp()
      .then((res) => {
        if (res.status) {
          setOpenOtpModal(true);
          setOtpUid(res.otp_uid);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setBtnLoading(false));
  };

  const handleVerify = () => {
    setBtnLoading(true);
    const formdata = new FormData();
    formdata.append("latitude", getLocalStorageItem("latitude"));
    formdata.append("otp_uid", otpUid);
    formdata.append("otp", otp);
    formdata.append("longitude", getLocalStorageItem("longitude"));
    Object.keys(filledDetails).map((i) => formdata.append(i, filledDetails[i]));
    PayCreditCardBill(formdata)
      .then((res) => {
        if (res.status) {
          dispatchtoast(res.message);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => {
        setBtnLoading(false);
        form.resetFields();
        setOpenOtpModal(false);
      });
  };
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-1 place-items-start">
        <div className="prepaid animate-slide-in w-full md:w-1/2 bg-white shadow-normal  rounded-3xl p-5">
          <p className="font-bold text-[15px] mb-2"> Credit Card</p>
          <Form
            name="form"
            form={form}
            onFinishFailed={(err) => console.log(err)}
            onFinish={(val) => handlePay(val)}
          >
            <Form.Item
              name={`bank_id`}
              label={"Select Bank"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Select One Bank!",
                },
              ]}
            >
              <Select
                placeholder="Select a bank"
                className="w-full mt-2"
                options={creditCardbanks}
              />
            </Form.Item>
            <Form.Item
              name={`card_number`}
              label={"Card Number"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter Card Number!",
                },
                {
                  pattern: creditCardValidation,
                  message: "Enter valid Card Number!",
                },
                {
                  whitespace: true,
                  message: "Field cannot contain only blank spaces",
                },
              ]}
            >
              <CommonInput
                onInput={(e) => {
                  const value = e.target.value.toUpperCase();
                  e.target.value = value;
                }}
                placeholder="Enter IFSC"
                name="benificiary_ifsc"
              />
            </Form.Item>{" "}
            <Form.Item
              name={`customer_mobile`}
              label={"Mobile No."}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter Mobile no!",
                },
                {
                  whitespace: true,
                  message: "Field cannot contain only blank spaces",
                },
              ]}
            >
              <CommonInput
                onInput={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  e.target.value = value;
                }}
                placeholder="Enter Mobile No"
                name="amount"
              />
            </Form.Item>
            <Form.Item
              name={`card_holder_name`}
              label={"Card Holder Name"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter Card Holder Name!",
                },
                {
                  whitespace: true,
                  message: "Field cannot contain only blank spaces",
                },
              ]}
            >
              <CommonInput
                placeholder="Enter Benificiary Name"
                name="benificiary_name"
              />
            </Form.Item>{" "}
            <Form.Item
              name={`amount`}
              label={"Amount"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter Amount!",
                },
                {
                  whitespace: true,
                  message: "Field cannot contain only blank spaces",
                },
              ]}
            >
              <CommonInput
                onInput={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  e.target.value = value;
                }}
                placeholder="Enter Amount"
                name="amount"
              />
            </Form.Item>
            <Button
              loading={btnLoading}
              className="w-full bg-primary border-none mt-4"
              style={{ color: "white" }}
              htmlType="submit"
            >
              Pay
            </Button>
          </Form>
        </div>
      </div>
      {openOtpModal && (
        <Modal
          title={"Verify OTP"}
          footer={null}
          className="shadow-normal"
          width={300}
          maskClosable={false}
          open={openOtpModal}
          onCancel={() => setOpenOtpModal(false)}
        >
          <div className="  rounded-3xl shadow-normal bg-white ">
            <Form onFinish={(v) => handleVerify(v)} labelCol={{ span: 24 }}>
              <Form.Item
                name={"otp"}
                label="otp"
                rules={[
                  {
                    required: true,
                    message: "Enter otp",
                  },
                ]}
              >
                <div className=" mt-5 flex justify-center items-center">
                  <Input.OTP onChange={(v) => setOtp(v)} />
                </div>
              </Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={btnLoading}
                className={`SignInBtn w-full flex justify-center border-none items-center h-12 mt-4  rounded-full text-white text-[12px] font-bold`}
              >
                <p>Verify OTP</p>
              </Button>
            </Form>
          </div>
        </Modal>
      )}
    </>
  );
};

export default EkoCreditCard;
